export const fontWeights = {
    regular: 400,
    medium: 500,
    bold: 700,
};
export const fontStyles = {
    normal: 'normal',
    italic: 'oblique',
};
export const fontFamily = {
    roboto: 'Roboto, Helvetica, Arial, sans-serif',
};
